export class ApiError {
  public status: number;
  public data: any;
  public traceId: string;
  public type: string;

  constructor(status: number = null, data = null, tradeId = '', type = '') {
    this.status = status;
    this.data = data;
    this.traceId = tradeId;
    this.type = type;
  }
}
